import { render, staticRenderFns } from "./WorkgroupPage.vue?vue&type=template&id=7ac6fb50&"
import script from "./WorkgroupPage.vue?vue&type=script&lang=js&"
export * from "./WorkgroupPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports